import { render, staticRenderFns } from "./AnswerVideo.vue?vue&type=template&id=0e38d95f&scoped=true"
import script from "./AnswerVideo.vue?vue&type=script&lang=js"
export * from "./AnswerVideo.vue?vue&type=script&lang=js"
import style0 from "./AnswerVideo.vue?vue&type=style&index=0&id=0e38d95f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e38d95f",
  null
  
)

export default component.exports